var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_html.js
// module id = 605
// module chunks = 168707334958949